import React from 'react';
import tpl from '../templates/routine-work';
import {View} from 'MWC';

export default class extends View {
    template = tpl;

    constructor(props) {
        super(props);
        return this;
    }

    static displayName = 'OpenBanking.RoutineWork';
}
